"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var MainMenuReset = /*#__PURE__*/function (_React$Component) {
  _inherits(MainMenuReset, _React$Component);

  function MainMenuReset(props) {
    var _this;

    _classCallCheck(this, MainMenuReset);

    _this = _possibleConstructorReturn(this, (MainMenuReset.__proto__ || Object.getPrototypeOf(MainMenuReset)).call(this, props));
    _this.state = {
      path: _this.props.location.path
    };
    _this.componentDidMount = _this.componentDidMount.bind(_assertThisInitialized(_this));
    _this.isActive = _this.isActive.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MainMenuReset, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item reset"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: this.props.text,
        href: "/reset-projects",
        className: 'main-nav__link ' + this.isActive('/reset-projects')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-reset-project"
      })));
    }
  }, {
    key: "isActive",
    value: function isActive(path) {
      return this.props.location.pathname === path ? 'is-active' : '';
    }
  }]);

  return MainMenuReset;
}(_react.default.Component);

MainMenuReset.propTypes = {
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string,
    path: _propTypes.default.string
  }),
  text: _propTypes.default.string
};
var _default = MainMenuReset;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/main-menu/menu-entry-reset.js
// module id = 712
// module chunks = 0